import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorBase } from '@shared/bases/control-value-accessor.base';
import { SharedModule } from '@shared/modules/shared.module';

@Component({
	selector: 'app-search',
	imports: [SharedModule],
	templateUrl: './search.component.html',
	styleUrl: './search.component.scss',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => SearchComponent),
			multi: true,
		},
	],
})
export class SearchComponent extends ControlValueAccessorBase<any> {
	private readonly MAX_LABEL_LENGTH = 40;
	private _suggestions: { label: string; value: any }[] = [];

	@Input() size: 'small' | 'medium' | 'large' = 'large';
	@Input() placeholder = '';
	@Input() disabled = false;
	@Input() error = false;
	@Input() errorMessage = '';
	@Input() label?: string;
	@Input() showIcon = true;

	@Input()
	set suggestions(value: { label: string; value: any }[]) {
		this._suggestions = value.map((suggestion) => ({
			...suggestion,
			label: this.truncateText(suggestion.label, this.MAX_LABEL_LENGTH),
		}));
	}

	get suggestions(): { label: string; value: any }[] {
		return this._suggestions;
	}

	searchId = `search-${Math.random().toString(36).substring(2, 11)}`;
	isDropdownOpen = false;
	searchResults: { label: string; value: any }[] = [];
	selectedItem: { label: string; value: any } | null = null;

	set selectedOption(item: { label: string; value: any } | null) {
		this.selectedItem = item;
		const value = item ? item.value : null;
		this.value = value;
		this.notifyValueChange(value);
	}

	get selectedOption(): { label: string; value: any } | null {
		// If value exists, find the corresponding item in suggestions
		if (this.value) {
			const found = this._suggestions.find((s) => s.value === this.value);
			return found || this.selectedItem;
		}
		return null;
	}

	onDropdownOpen(): void {
		this.isDropdownOpen = true;
	}

	onDropdownClose(): void {
		this.isDropdownOpen = false;
	}

	search(event: any): void {
		const query = event.query.toLowerCase();
		if (!query) {
			this.searchResults = this.suggestions;
		} else {
			this.searchResults = this.suggestions.filter((item) => item.label.toLowerCase().includes(query));
		}
	}

	private truncateText(text: string, maxLength: number): string {
		return text.length > maxLength ? `${text.substring(0, maxLength)}...` : text;
	}
}
